"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.upgrade.subject': '账户升级成功',
    'email.upgrade.title': '您的账户已升级！',
    'email.upgrade.text': '好消息！您的账户已成功升级，现在可以使用增强功能。',
    'email.upgrade.new_plan': '新计划',
    'email.upgrade.benefits': '您现在可以享受新订阅计划的所有好处。',
    'email.upgrade.dashboard_button': '前往控制台',
    'email.upgrade.footer': '感谢您选择IntHub！',
};
